import { ContactType } from '../enums/contact-type.enum';
import { EntityStatus } from '../enums/entity-status.enum';
import { PhoneType } from '../enums/phone-type.enum';
import { IAddress } from './address.interface';

export interface IContact {
  contactUid?: string;
  isPrimary?: boolean;
  contactType: ContactType;
  contactTypeFormatted?: string;
  name: {
    firstName: string;
    lastName: string;
  };
  phoneNumbers: {
    isPrimary?: boolean;
    value: string;
    phoneType: PhoneType;
  }[];
  email: string;
  addresses?: IAddress[];
  status: EntityStatus;
  createdDate: string;
  modifiedDate: string;
  version: number;
}
